module.exports = __webpack_public_path__ + "img/pen.3eee0439.png";